<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />
    <main class="a-service-main">
      <div class="a-service-container">
        <div class="cont_section cont_section_new">
          <agreement-pollbox-age
            :selected-intaker="selectedIntaker"
            :selected-age="selectedAge"
            @update-intaker="updateIntaker"
            @update-age="updateAge"
          />
          <agreement-pollbox-sex v-model="selectedSex" />
          <div class="poll_box poll_box_agree">
            <div class="terms_wrap">
              <div class="box_title_area">
                <h3 class="service-title-b">
                  마이 팩 by 뉴트리라이트 신청을 위한 정보 동의를 해주세요.
                </h3>
              </div>
              <div class="terms_group">
                <div class="inner">
                  <agreement-terms
                    v-model="refundAgreed"
                    title="청약철회(취소·교환·환불·반품) 불가 사전 동의(필수)"
                    :type="typeRefund"
                    :show-all="false"
                    @change="onChangeAgreement"
                  >
                    <!-- <term-refund /> -->
                  </agreement-terms>
                  <p>
                    마이팩 by 뉴트리라이트 제품은 '한국 암웨이 소비자 만족
                    보증제도'가 적용되지 않으며, 구매 후 단순변심에 의한 반품이
                    불가합니다. 기타사항은 공정거래위원회 고시
                    '소비자분쟁해결기준' 및 방문판매법에 따릅니다.
                  </p>
                  <agreement-terms
                    v-model="privacyAgreed"
                    title="개인정보 수집·이용 동의(필수)"
                    :type="typePrivacy"
                    :show-all="true"
                    @change="onChangeAgreement"
                  >
                    <term-privacy />
                  </agreement-terms>
                  <agreement-terms
                    v-if="intakerSelf"
                    v-model="sensitiveAgreed"
                    title="민감정보 수집·이용 동의(필수)"
                    :type="typeSensitive"
                    :show-all="true"
                    @change="onChangeAgreement"
                  >
                    <term-sensitive />
                  </agreement-terms>
                  <agreement-terms
                    v-model="consultationAgreed"
                    title="상담 규정 및 상담 시 유의사항(필수)"
                    :type="typeConsultation"
                    :show-all="true"
                    @change="onChangeAgreement"
                  >
                    <term-consultation />
                  </agreement-terms>
                  <agreement-terms
                    v-if="intakerOther"
                    v-model="proxyConsentAgreed"
                    title="섭취자 본인에게 대리 상담에 관하여 충분히 설명하고, 정보 수집에 대한 동의를 받은 후 상담을 진행하시기 바랍니다. (자세한 사항은 마이팩 이용 가이드 참고)"
                    :type="typeProxyConsent"
                    :show-all="false"
                    @change="onChangeAgreement"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <main-button-group
          :disabled-right="!canProceed"
          title-left="이전"
          title-right="다음"
          @click-left="$router.back()"
          @click-right="onClickNext"
        />
      </div>
      <floating-button-group
        title="다음"
        :disabled="!canProceed"
        @click="onClickNext"
      />
    </main>
    <app-footer />
  </div>
</template>

<script>
import { AGREEMENT_TYPE, CONTEXT_TYPE, INTAKER_TYPE } from "@/utils/constants";
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import { log } from "@/utils/common";
import FloatingButtonGroup from "@/components/FloatingButtonGroup.vue";
import MainButtonGroup from "@/components/MainButtonGroup.vue";
// import TermRefund from "@/views/agreement/terms/TermRefund.vue";
import TermPrivacy from "@/views/agreement/terms/TermPrivacy.vue";
import TermSensitive from "@/views/agreement/terms/TermSensitive.vue";
import TermConsultation from "@/views/agreement/terms/TermConsultation.vue";
import AgreementTerms from "./partial/AgreementTerms.vue";
import AgreementPollboxAge from "./partial/AgreementPollboxAge.vue";
import AgreementPollboxSex from "./partial/AgreementPollboxSex.vue";

export default {
  name: "Agreement",
  components: {
    AppHeader,
    AppFooter,
    AgreementTerms,
    AgreementPollboxAge,
    AgreementPollboxSex,
    FloatingButtonGroup,
    MainButtonGroup,
    // TermRefund,
    TermPrivacy,
    TermSensitive,
    TermConsultation,
  },
  data() {
    return {
      pageTitle: "약관동의",
      typeRefund: AGREEMENT_TYPE.REFUND,
      typePrivacy: AGREEMENT_TYPE.PRIVACY,
      typeSensitive: AGREEMENT_TYPE.SENSITIVE,
      typeConsultation: AGREEMENT_TYPE.CONSULTATION,
      typeProxyConsent: AGREEMENT_TYPE.PROXY_CONSENT,
      refundAgreed: false,
      privacyAgreed: false,
      sensitiveAgreed: false,
      consultationAgreed: false,
      proxyConsentAgreed: false,
      selectedIntaker: null,
      selectedAge: null,
      selectedSex: null,
    };
  },
  computed: {
    ...mapGetters({
      agreed: "agreement/agreed",
      proceed: "agreement/canProceed",
      targetIntaker: "agreement/targetIntaker",
      targetRange: "agreement/targetRange",
      targetSex: "agreement/targetSex",
    }),
    canProceed() {
      if (
        this.agreed &&
        this.selectedIntaker &&
        this.selectedAge &&
        this.selectedSex
      ) {
        return true;
      }
      return false;
    },
    intakerSelf() {
      return this.selectedIntaker == INTAKER_TYPE.SELF;
    },
    intakerOther() {
      return this.selectedIntaker == INTAKER_TYPE.OTHER;
    },
  },
  watch: {
    selectedIntaker() {
      this.$store.dispatch("agreement/updateTargetIntaker", {
        targetIntaker: this.selectedIntaker,
      });
    },
    selectedAge() {
      this.$store.dispatch("agreement/updateTargetRange", {
        targetRange: this.selectedAge,
      });
    },
    selectedSex() {
      this.$store.dispatch("agreement/updateTargetSex", {
        targetSex: this.selectedSex,
      });
    },
  },
  created() {
    if (this.proceed) this.recoverState();
    // this.$store.dispatch('agreement/init');
  },
  mounted() {},
  methods: {
    onChangeAgreement(payload) {
      this.$store.dispatch("agreement/updateAgreementType", {
        type: payload.type,
        accepted: payload.accepted,
      });
    },
    checkSelection() {},
    onClickNext() {
      const nextPath = this.$route.params.type;
      log("Agreement::onClickNext", `agreement type is ${nextPath}`);
      if (nextPath) {
        switch (nextPath) {
          case CONTEXT_TYPE.RECOMPOSITION:
            this.$router.push(`/composition/${nextPath}`);
            break;
          case CONTEXT_TYPE.COMPOSITION_FINAL:
            this.$router.push("/composition/step3");
            break;
          case CONTEXT_TYPE.COMPOSITION_REORDER:
            this.$router.push("/composition/step3");
            break;
          default:
            this.$router.push("/composition");
        }
      } else {
        this.$router.push("/");
      }
    },
    recoverState() {
      this.selectedIntaker = this.targetIntaker;
      this.selectedAge = this.targetRange;
      this.selectedSex = this.targetSex;

      this.refundAgreed = true;
      this.privacyAgreed = true;
      this.consultationAgreed = true;

      if (this.intakerSelf) {
        this.sensitiveAgreed = true;
        this.proxyConsentAgreed = false;
      } else if (this.intakerOther) {
        this.sensitiveAgreed = false;
        this.proxyConsentAgreed = true;
      }
    },
    updateIntaker(value) {
      this.selectedIntaker = value;
    },
    updateAge(value) {
      this.selectedAge = value;
    },
  },
};
</script>
<style scoped>
.box_title_area {
  margin-bottom: 10px;
}
</style>
